var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-buttonv2--pill",class:{
    'ui-buttonv2--block': _vm.block,
    [`ui-buttonv2--${_vm.size}`]: true,
    [`ui-buttonv2--${_vm.variant}`]: true,
  },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }